import { lang, commonLang, _lang } from '@umu/ukit-lang';
/***
 * @file 收藏反馈
 *
 */

import React, { useCallback } from 'react';
import './firstCollectDialog.scss';
import { components } from 'common';
const { Button } = components;

interface IProps {
    closeDialog: () => void;
}
export function FirstCollectDialog(props: IProps) {
    const onClose = useCallback(() => {
        props.closeDialog();
    }, []);

    const renderCollectInfo = () => {
        if (_lang('en')) {
            return <p>{'Go to your profile to view and manage your favorites'}</p>;
        }
        return (
            <>
                <p>{lang('点击头像，找到“我的收藏”,')}</p>
                <p>{lang('就能查看和管理收藏了。')}</p>
            </>
        );
    };

    return (
        <div className="first-collect-dialog">
            <div className="collect-header">
                <i className="icon icon-entity entity-first-collect"></i>
            </div>
            <div className="collect-title">{lang('已添加至收藏')}</div>
            <div className="collect-info">
                {renderCollectInfo()}
            </div>
            <div className="collect-bg">
                <div className="entry-title">{lang('我的收藏')}</div>
            </div>
            <div className="collect-footer">
                <Button className="collect-footer-btn" type="optional" onClick={onClose}>
                    {commonLang('确定_GOT_IT')}
                </Button>
            </div>
        </div>
    );
}
